import ButtonCustom from '@/components/ui/ui-react-antd/MyButton/Button'
import { MenuUnfoldOutlined } from '@ant-design/icons'
import { Col, FloatButton, Row } from 'antd'
import { ChevronsLeft } from 'lucide-react'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import MenuLeft from '../MenuLeft'
import { UserMenuStyled } from './styled'

interface LayoutAdminProps {
  children?: React.ReactNode
  selectedKey?: string[]
  menuAdmin?: any[]
  onClickMenu?: (menu: any) => void
}

const LayoutAdmin = ({
  children,
  selectedKey = ['/'],
  menuAdmin = [],
  onClickMenu = () => {},
}: LayoutAdminProps) => {
  const [collapsemenu, setcollapsemenu] = useState(false)
  const [hiddenMenu, setHiddenMenu] = useState(false)
  const location = useLocation()

  const onChange = (menu: any) => {
    onClickMenu(menu)
    const bodyAdmin = document.getElementById('body-admin-scroll')
    !!bodyAdmin && bodyAdmin.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: Dùng location làm trigger chuyển trang
  useEffect(() => {
    const bodyAdmin = document.getElementById('body-admin-scroll')
    !!bodyAdmin && bodyAdmin.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [location])

  useEffect(() => {
    setcollapsemenu(false)
  }, [])

  return (
    <Row gutter={12} style={{ flexWrap: 'nowrap' }}>
      {menuAdmin.length > 0 && (
        <Col>
          <UserMenuStyled $themedark={false} $collapsemenu={collapsemenu}>
            <div className={`side-bar-wrapper d-flex justify-content-space-between flex-column`}>
              <MenuLeft
                onChange={onChange}
                selectedKey={selectedKey}
                menu={menuAdmin}
                collapsemenu={collapsemenu}
              />
              <div style={{ marginLeft: 10 }}>
                <ButtonCustom
                  variant="text"
                  className="collapsed-item"
                  onClick={() => setcollapsemenu(!collapsemenu)}
                >
                  <div className="d-flex-center">
                    <div className="d-flex-center">
                      <ChevronsLeft
                        size={18}
                        style={{ rotate: collapsemenu ? '180deg' : '0deg' }}
                      />
                    </div>
                    <div className="collapsed-title">Thu gọn</div>
                  </div>
                </ButtonCustom>
              </div>
            </div>
          </UserMenuStyled>
        </Col>
      )}
      {!!hiddenMenu && (
        <FloatButton
          style={{ left: 20 }}
          onClick={() => setHiddenMenu(false)}
          tooltip={'Mở menu'}
          icon={<MenuUnfoldOutlined />}
        />
      )}
      <Col
        flex="auto"
        style={{
          backgroundColor: '#fff',
          width: 0,
          overflow: 'hidden auto',
          marginLeft: hiddenMenu ? '5px' : 0,
          paddingTop: '6px',
          height: 'calc(100vh - 45px)',
        }}
        id="body-admin-scroll"
      >
        {children}
      </Col>
    </Row>
  )
}

export default LayoutAdmin
